import type { PlotStatusKind } from '../model/types';

export type PlotStatusTone = 'red' | 'amber' | 'green' | 'sage' | 'blue';

export interface PlotStatusPresentation {
  label: string;
  shortLabel: string;
  ariaLabel: string;
  tone: PlotStatusTone;
}

export const plotStatusPresentations: Record<PlotStatusKind, PlotStatusPresentation> = {
  sold: {
    label: 'Продан',
    shortLabel: 'Продан',
    ariaLabel: 'продан',
    tone: 'red',
  },
  reserved: {
    label: 'Зарезервирован',
    shortLabel: 'Резерв',
    ariaLabel: 'зарезервирован',
    tone: 'amber',
  },
  free: {
    label: '500 тыс. ₽ / сотка',
    shortLabel: '500 тыс. ₽',
    ariaLabel: '500 тысяч рублей за сотку',
    tone: 'green',
  },
  'price-per-sotka': {
    label: '500 тыс. ₽ / сотка',
    shortLabel: '500 тыс. ₽',
    ariaLabel: '500 тысяч рублей за сотку',
    tone: 'green',
  },
  'price-per-sotka-with-contractor': {
    label: '520 тыс. ₽ / сотка, с подрядом',
    shortLabel: 'С подрядом',
    ariaLabel: '520 тысяч рублей за сотку, с подрядом',
    tone: 'blue',
  },
};

export function getPlotStatusPresentation(kind: PlotStatusKind): PlotStatusPresentation {
  return plotStatusPresentations[kind];
}
